/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { ReactNode, useEffect } from 'react';
import LoadingSpinner from './loading';
import { useKeycloak } from '@react-keycloak/web';

interface ProtectedAppProps {
  children: ReactNode;
}

export const ProtectedApp: React.FC<ProtectedAppProps> = ({ children }) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { keycloak, initialized } = useKeycloak();

  /**
   * Do auto sign in.
   *
   */

  useEffect(() => {
    if (initialized && !keycloak.authenticated) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      keycloak.login();
    }
  }, [initialized, keycloak]);

  // show a spinner during any ongoing OIDC navigation
  if (!initialized) {
    return <LoadingSpinner />;
  }

  // if we still aren’t authenticated (redirect in flight), render nothing
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (!keycloak.authenticated) {
    return null;
  }

  // if (auth.error) {
  //   return (
  //     <>
  //       <h1>We've hit a snag</h1>
  //       <Alert variant="error">OIDC Error: {auth.error.message}</Alert>
  //     </>
  //   );
  // }

  return <>{children}</>;
};
